// extracted by mini-css-extract-plugin
module.exports = {"item-with-image-hoverable":"item-with-image-hoverable__daDfn"};